/* Shoelosophy wishlist — salvata nel browser (localStorage), nessuna app esterna */
(function () {
  'use strict';
  if (window.SLWishlist) return;

  var KEY = 'sl_wishlist_v1';
  var MAX = 200;
  var cfg = window.SLWishlistConfig || {};
  var t = cfg.t || {};
  var root = document.documentElement;
  var memory = [];
  var HEART = '<svg viewBox="46 0.5 19 16.5" aria-hidden="true" focusable="false"><path d="M55.5 15.5S47.5 11 47.5 5.8Q47.5 2 51.3 2 53.8 2 55.5 4.4 57.2 2 59.7 2 63.5 2 63.5 5.8 63.5 11 55.5 15.5z"/></svg>';

  if (cfg.cards) root.classList.add('wl-cards');
  if (cfg.product) root.classList.add('wl-product');

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return memory.slice();
    }
  }

  function write(list) {
    memory = list.slice();
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  function handleFromUrl(href) {
    var m = /\/products\/([^\/?#]+)/.exec(href || '');
    if (!m) return null;
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }

  function paint(b, list) {
    var on = list.indexOf(b.getAttribute('data-wl-handle')) > -1;
    var label = on ? (t.remove || 'Remove from wishlist') : (t.add || 'Add to wishlist');
    b.classList.toggle('is-active', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.setAttribute('aria-label', label);
    b.setAttribute('title', label);
  }

  function sync() {
    var list = read();
    root.classList.toggle('wl-has-items', list.length > 0);
    var buttons = document.querySelectorAll('[data-wl-handle]');
    for (var i = 0; i < buttons.length; i++) paint(buttons[i], list);
  }

  function makeButton(handle, kind) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'wl-btn wl-btn--' + kind;
    b.setAttribute('data-wl-handle', handle);
    b.innerHTML = HEART;
    paint(b, read());
    return b;
  }

  /* ---------- avviso ---------- */
  var toastEl = null;
  var toastTimer = null;
  var onWishlistPage = false;

  function toast(added) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'wl-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    var icon = document.querySelector('.thb-secondary-wishlist .wl-icon');
    if (added && icon) toastEl.appendChild(icon.cloneNode(true));
    var text = document.createElement('span');
    text.textContent = added ? (t.added || 'Saved') : (t.removed || 'Removed');
    toastEl.appendChild(text);
    if (added && cfg.pageUrl && !onWishlistPage) {
      var a = document.createElement('a');
      a.href = cfg.pageUrl;
      a.textContent = t.view || 'View';
      toastEl.appendChild(a);
    }
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3000);
  }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    var added = i === -1;
    if (added) list.unshift(handle); else list.splice(i, 1);
    if (list.length > MAX) list = list.slice(0, MAX);
    write(list);
    sync();
    toast(added);
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { handle: handle, added: added, list: list } }));
    return added;
  }

  /* ---------- cuori su schede e scheda prodotto ---------- */
  function enhanceCards(scope) {
    var figs = (scope || document).querySelectorAll('product-card .product-card--featured-image');
    for (var i = 0; i < figs.length; i++) {
      var fig = figs[i];
      if (fig.querySelector('.wl-btn')) continue;
      var link = fig.querySelector('a.product-card--featured-image-link');
      var handle = link && handleFromUrl(link.getAttribute('href'));
      if (handle) fig.appendChild(makeButton(handle, 'card'));
    }
  }

  function enhanceProduct() {
    var handle = handleFromUrl(location.pathname);
    if (!handle) return;
    var holders = document.querySelectorAll('.add_to_cart_holder');
    for (var i = 0; i < holders.length; i++) {
      var holder = holders[i];
      if (holder.closest('product-drawer, quick-view-modal, .product-quick-view, .side-panel')) continue;
      if (holder.querySelector('.wl-btn')) return;
      var atc = holder.querySelector('.single-add-to-cart-button');
      if (!atc) continue;
      holder.classList.add('wl-has-btn');
      atc.insertAdjacentElement('afterend', makeButton(handle, 'product'));
      return;
    }
  }

  function enhanceMobileMenu() {
    var footer = document.querySelector('.thb-mobile-menu-footer');
    if (!footer || !cfg.pageUrl || footer.querySelector('.wl-mobile-link')) return;
    var a = document.createElement('a');
    a.className = 'thb-mobile-account-link wl-mobile-link';
    a.href = cfg.pageUrl;
    a.innerHTML = HEART;
    a.appendChild(document.createTextNode(' ' + (t.title || 'Wishlist')));
    footer.insertBefore(a, footer.firstChild);
  }

  /* ---------- pagina wishlist ---------- */
  function renderPage(page) {
    onWishlistPage = true;
    var grid = page.querySelector('[data-wl-grid]');
    var empty = page.querySelector('[data-wl-empty]');
    var list = read();
    if (!list.length) {
      grid.innerHTML = '';
      empty.hidden = false;
      page.classList.remove('is-loading');
      return;
    }
    empty.hidden = true;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    Promise.all(list.map(function (h) {
      return fetch(base + 'products/' + encodeURIComponent(h) + '?view=wishlist-card', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .catch(function () { return undefined; });
    })).then(function (results) {
      var html = '';
      var gone = [];
      results.forEach(function (res, i) {
        if (res && res.indexOf('product-card') > -1) {
          html += '<div class="wl-grid__item" data-wl-item="' + list[i].replace(/"/g, '&quot;') + '">' + res + '</div>';
        } else if (res === null) {
          gone.push(list[i]);
        }
      });
      if (gone.length) write(read().filter(function (h) { return gone.indexOf(h) === -1; }));
      grid.innerHTML = html;
      empty.hidden = html !== '';
      page.classList.remove('is-loading');
      enhanceCards(grid);
      sync();
    });

    document.addEventListener('wishlist:change', function (e) {
      if (e.detail.added) return;
      var items = grid.querySelectorAll('[data-wl-item]');
      for (var i = 0; i < items.length; i++) {
        if (items[i].getAttribute('data-wl-item') === e.detail.handle) items[i].parentNode.removeChild(items[i]);
      }
      if (!grid.children.length) empty.hidden = false;
    });
  }

  /* ---------- avvio ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-wl-handle]') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(b.getAttribute('data-wl-handle'));
  }, true);

  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });

  function init() {
    var page = document.querySelector('[data-wl-page]');
    if (page) renderPage(page);
    enhanceCards(document);
    enhanceProduct();
    enhanceMobileMenu();
    sync();

    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        enhanceCards(document);
        enhanceProduct();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.SLWishlist = { read: read, toggle: toggle, sync: sync };
})();
